<style lang="scss" scoped>
@use 'sass:color';
@use '../palette.scss' as *;

$dot-space: 12px;
$dot-size: 2px;
$header-height: 60px;

.navbar {
    background-color: $theme-dark-blue;
    padding: 0 15px;
    min-height: $header-height;
    color: color.adjust(white, $alpha: -0.5);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
        color: white;
        font-size: 1.2em;
        margin-bottom: 5px;
    }

    .nav-link-container {
        padding: 8px;
        margin: 0 5px;
        display: inline-flex;
        align-items: center;

        &:hover {
            color: color.adjust(white, $alpha: -0.25);
            cursor: pointer;
        }

        &.active {
            color: white;
        }
    }
}

.app-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    background:
        linear-gradient(90deg, white ($dot-space - $dot-size), transparent 1%)
            center,
        linear-gradient(white ($dot-space - $dot-size), transparent 1%) center,
        color.adjust($theme-light-grey, $alpha: -0.5);
    background-size: $dot-space $dot-space;
}

header {
    z-index: 100;
    box-shadow: $dark-shadow;
    position: fixed;
    width: 100%;
    max-height: 98vh;
    overflow-y: auto;

    .nav-header {
        display: flex;
        flex-flow: column;
        padding: 9px;
        background-color: $theme-dark-blue;

        &.open {
            .nav-divider.collapsible {
                display: flex;
            }
        }

        .nav-divider {
            display: flex;
            flex-flow: column;

            &.collapsible {
                display: none;
            }

            .nav-link-container {
                padding: 8px 15px;

                a {
                    color: color.adjust(white, $alpha: -0.5);
                    text-decoration: none;

                    &.active {
                        color: white;
                    }

                    &:hover {
                        color: white;
                        cursor: pointer;
                    }
                }
            }

            .title-block {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .title {
                    color: white;
                    font-size: 1.2em;
                    font-weight: bold;
                    margin-right: 15px;
                }

                .hamburger {
                    display: inline-flex;
                    flex-flow: column;
                    align-items: center;
                    justify-content: center;
                    height: 35px;
                    width: 35px;
                    border-radius: 3px;
                    border: 1px solid $theme-dark-blue;

                    &:hover {
                        cursor: pointer;
                        border: 1px solid
                            color.adjust($theme-light-grey, $alpha: -0.6);
                    }

                    &:active {
                        background-color: color.adjust(
                            $theme-dark-blue,
                            $lightness: -5%
                        );
                    }

                    div:last-child {
                        margin-bottom: 0;
                    }

                    .line {
                        width: 60%;
                        height: 2px;
                        background-color: white;
                        margin-bottom: 5px;
                        border-radius: 1px;
                    }
                }
            }
        }

        .button {
            display: inline-flex;
            align-items: center;
            color: color.adjust(white, $alpha: -0.5);
            background-color: transparent;
            height: 100%;
            border: none;
            padding: 8px 15px;
            z-index: 5;

            &:focus {
                outline: none;
                box-shadow: none;
            }

            &:hover {
                color: color.adjust(white, $alpha: -0.25);
                cursor: pointer;
            }

            .fa {
                margin-left: 8px;
                transition: transform 0.5s;

                &.fa-clock {
                    margin: 0 8px 0 0;
                }
            }
        }

        .nav-dropdown {
            z-index: 5;
            position: relative;
            background-color: $theme-dark-blue;

            &.open {
                .button {
                    background-color: $theme-blue;
                    color: white;

                    .fa {
                        transform: rotate(-180deg);
                    }
                }

                .menu {
                    display: block;
                }
            }

            .menu {
                background-color: $theme-blue;
                color: white;
                box-shadow: $dark-shadow;
                min-width: 100%;
                padding: 0 12px 8px;
                top: 100%;
                left: 0;
                z-index: 1;
                display: none;

                span.active {
                    color: white;
                }

                &.open-left {
                    right: 0;
                    left: initial;
                }

                &.open-left-columned {
                    column-count: 2;
                    right: 0;
                    left: initial;
                }

                .column {
                    display: flex;
                    flex-direction: column;
                    width: 160px;
                    gap: 4px;
                }

                .item {
                    display: block;
                    width: 100%;
                    padding: 10px 5px;

                    a {
                        color: color.adjust(white, $alpha: -0.5);
                        text-decoration: none;

                        &:hover {
                            cursor: pointer;
                            color: color.adjust(white, $alpha: -0.25);
                        }

                        &:hover {
                            cursor: pointer;
                        }
                    }
                }

                .hrefitem {
                    display: block;
                }

                .divider {
                    border-top: 1px solid color.adjust(white, $alpha: -0.5);
                }
            }
        }

        .version-label {
            display: none;
        }
    }

    @media (max-width: 899px) {
        .version-label {
            justify-content: center;
            padding: 5px 0;
            font-size: 0.9em;
            color: color.adjust(white, $alpha: -0.5);
        }
    }

    @media (min-width: 900px) {
        overflow-y: visible;

        .nav-header {
            flex-flow: row nowrap;
            justify-content: space-between;

            .nav-divider {
                flex-flow: row nowrap;
                align-items: baseline;

                &.collapsible {
                    display: flex;
                }

                .title-block {
                    align-items: default;

                    .hamburger {
                        display: none;
                    }
                }

                &.footer-block {
                    display: none;
                }
            }

            .nav-dropdown {
                .menu {
                    position: absolute;
                }
            }

            .version-label {
                display: flex;
                align-items: center;
                color: color.adjust(white, $alpha: -0.5);
            }
        }
    }
}

main {
    flex: 1;
    overflow: auto;
    padding: 35px 0 0 15px;
    margin-top: $header-height;
}

.footer {
    display: none;

    @media (min-width: 900px) {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 0;
        background-color: #ffffff;
        box-shadow: 0 -5px 10px 0 color.adjust($theme-grey, $alpha: -0.7);
        z-index: 10;
    }
}

.footer-button {
    width: 33%;
    line-height: 1;
    &:hover {
        background-color: transparent;
    }
}

.footer .dropdown-item {
    padding: 10px;
}

.div-footer {
    width: 33%;
    display: inline-block;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    padding: 8px 0;

    .fa-clock {
        margin-right: 6px;
    }

    .dropdown-container {
        min-width: 170px;
    }
}

.div-button {
    border: 1px solid;
    border-color: $theme-light-blue;
    border-radius: 0.25rem;
    color: $theme-light-blue;
    display: inline-block;
    font-size: 1rem;
    font-weight: 400;
    font-size: 1rem;
    margin: 10px;
    padding: 4px 8px;
    text-align: center;
    &:hover {
        text-decoration: none;
    }
    transition:
        color 0.15s ease-in-out,
        background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
}

:deep(.modal-body) {
    .campaign-list {
        display: flex;
        flex-direction: column;
        padding: 0 5px;

        div:last-child {
            border-bottom: none;
        }

        .campaign-slot {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px;
            border-bottom: 1px dashed $theme-light-grey;
            min-height: 59px;

            .data-block {
                margin-right: 8px;
                flex-grow: 1;

                .campaign-name {
                    color: $theme-blue;
                    font-weight: bold;
                }

                .campaign-id {
                    color: color.adjust($theme-light-grey, $lightness: -5%);
                    font-weight: bold;
                    font-style: italic;
                }
            }

            &:hover {
                background-color: color.adjust(white, $lightness: -5%);
                cursor: pointer;
            }

            &:active {
                background-color: color.adjust(white, $lightness: -10%);
            }
        }
    }

    .modal-save-block {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;

        &.saving {
            .spinner-container {
                display: flex;
            }

            .button-block {
                display: none;
            }
        }

        .spinner-container {
            display: none;
            align-items: center;
            justify-content: center;
            height: 60px;
            width: 60px;

            .blocks {
                position: relative;
                width: 100%;
                height: 100%;

                .block {
                    position: absolute;
                    width: 35%;
                    height: 35%;
                    border-radius: 3px;
                    animation-duration: 0.5s;
                    animation-iteration-count: infinite;
                    animation-timing-function: linear;

                    &.one {
                        left: 10%;
                        top: 10%;
                        animation-name: blockone;
                        background-color: $theme-dark-blue;
                    }

                    &.two {
                        left: 55%;
                        top: 10%;
                        animation-name: blocktwo;
                        background-color: $theme-blue;
                    }

                    &.three {
                        left: 55%;
                        top: 55%;
                        animation-name: blockthree;
                        background-color: $theme-light-blue;
                    }

                    @keyframes blockone {
                        50% {
                            left: 10%;
                            top: 10%;
                            background-color: $theme-dark-blue;
                        }

                        100% {
                            left: 55%;
                            top: 10%;
                            background-color: $theme-blue;
                        }
                    }

                    @keyframes blocktwo {
                        25% {
                            left: 55%;
                            top: 10%;
                            background-color: $theme-blue;
                        }

                        50% {
                            left: 55%;
                            top: 55%;
                            background-color: $theme-light-blue;
                        }

                        100% {
                            left: 55%;
                            top: 55%;
                            background-color: $theme-light-blue;
                        }
                    }

                    @keyframes blockthree {
                        0% {
                            left: 55%;
                            top: 55%;
                            background-color: $theme-light-blue;
                        }

                        50% {
                            left: 10%;
                            top: 55%;
                            background-color: color.adjust(
                                $theme-blue,
                                $lightness: 20%
                            );
                        }

                        75% {
                            left: 10%;
                            top: 55%;
                            background-color: color.adjust(
                                $theme-blue,
                                $lightness: 20%
                            );
                        }

                        100% {
                            left: 10%;
                            top: 10%;
                            background-color: $theme-dark-blue;
                        }
                    }
                }
            }
        }
    }
}
</style>

<template>
    <div class="app-container">
        <header>
            <div class="nav-header" :class="{ open: navOpen }">
                <div class="nav-divider">
                    <div class="title-block">
                        <div class="title">T-Star</div>
                        <div
                            class="hamburger"
                            @click="
                                navOpen
                                    ? (navShouldBeOpen = false)
                                    : (navShouldBeOpen = true)
                            "
                        >
                            <div class="line"></div>
                            <div class="line"></div>
                            <div class="line"></div>
                        </div>
                    </div>
                    <div class="nav-divider collapsible" @click="navClick">
                        <div class="nav-link-container">
                            <router-link to="/dashboard" active-class="active">
                                <span v-if="$t && $t('dashboard')">{{
                                    $t('dashboard')
                                }}</span>
                            </router-link>
                        </div>
                        <div class="nav-link-container">
                            <router-link
                                to="/unit"
                                active-class="active"
                                v-if="unitData"
                            >
                                <span>{{ $t('unit') }}</span>
                            </router-link>
                        </div>
                        <div
                            v-if="
                                isUserAdmin ||
                                isCampaignManager ||
                                isOrganizationAdmin
                            "
                            class="nav-dropdown"
                            menu="admin"
                            :class="{ open: menusOpen.admin }"
                            @click="toggleMenu('admin', $event)"
                        >
                            <button role="button" class="button">
                                {{ $t('administration') }}
                                <i class="fa fa-caret-down"></i>
                            </button>
                            <div class="menu">
                                <div
                                    class="item"
                                    v-if="
                                        isUserAdmin ||
                                        isCampaignManager ||
                                        isOrganizationAdmin
                                    "
                                >
                                    <router-link
                                        to="/admin/campaigns"
                                        active-class="active"
                                    >
                                        <span>{{ $t('campaign_plural') }}</span>
                                    </router-link>
                                </div>
                                <div
                                    class="item"
                                    v-if="isUserAdmin || isOrganizationAdmin"
                                >
                                    <router-link
                                        to="/admin/units"
                                        active-class="active"
                                    >
                                        <span>{{ $t('unit_plural') }}</span>
                                    </router-link>
                                </div>
                                <div
                                    class="item"
                                    v-if="isUserAdmin || isOrganizationAdmin"
                                >
                                    <router-link
                                        to="/admin/users"
                                        active-class="active"
                                    >
                                        <span>{{ $t('user_plural') }}</span>
                                    </router-link>
                                </div>
                                <div
                                    class="item"
                                    v-if="isUserAdmin || isOrganizationAdmin"
                                >
                                    <router-link
                                        to="/admin/auditlogs"
                                        active-class="active"
                                    >
                                        <span>{{ $t('auditLog.base') }}</span>
                                    </router-link>
                                </div>
                                <div
                                    class="item"
                                    v-if="isUserAdmin || isOrganizationAdmin"
                                >
                                    <router-link
                                        to="/admin/messageLogs"
                                        active-class="active"
                                    >
                                        <span>{{ $t('messageLog') }}</span>
                                    </router-link>
                                </div>
                                <div
                                    class="item"
                                    v-if="
                                        isUserAdmin ||
                                        isCampaignManager ||
                                        isOrganizationAdmin
                                    "
                                >
                                    <router-link
                                        to="/admin/fences"
                                        active-class="active"
                                    >
                                        <span>{{ $t('fence_plural') }}</span>
                                    </router-link>
                                </div>
                                <div
                                    class="item"
                                    v-if="isUserAdmin || isOrganizationAdmin"
                                >
                                    <router-link
                                        to="/admin/organizationManagement"
                                        active-class="active"
                                    >
                                        <span>{{
                                            $t('organizationManagement')
                                        }}</span>
                                    </router-link>
                                </div>
                                <div class="item" v-if="isUserAdmin">
                                    <a :href="admin_dsp" target="_blank">
                                        <span>{{ $t('admin_dsp') }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="nav-divider version-label">v. {{ appVersion }}</div>

                <div class="nav-divider collapsible" @click="navClick">
                    <div
                        class="nav-dropdown"
                        :class="{ open: menusOpen.language }"
                        @click="toggleMenu('language', $event)"
                    >
                        <button role="button" class="button">
                            {{ $t('language') }}
                            <i class="fa fa-caret-down"></i>
                        </button>

                        <div class="menu open-left-columned">
                            <div class="column">
                                <div
                                    v-for="language in languages"
                                    class="item"
                                    @click="
                                        $store.commit('setLang', language.value)
                                    "
                                    :key="language.value"
                                >
                                    {{ language.label }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="nav-dropdown"
                        :class="{ open: menusOpen.user }"
                        @click="toggleMenu('user', $event)"
                    >
                        <button role="button" class="button">
                            {{ username }}
                            <i class="fa fa-caret-down"></i>
                        </button>
                        <div class="menu open-left">
                            <div class="item">
                                <router-link to="/me" active-class="active">
                                    <span>{{ $t('edit') }}</span>
                                </router-link>
                            </div>
                            <div class="item" @click="logout">
                                {{ $t('logout') }}
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="nav-divider collapsible footer-block"
                    @click="navClick"
                >
                    <button role="button" class="button" @click="toggleUtcTime">
                        <i class="fa fa-clock" />
                        {{ timeView }}
                    </button>
                    <button
                        role="button"
                        class="button"
                        @click="showCampaignSelection = true"
                    >
                        {{ campaignLabel }}
                    </button>
                </div>
            </div>
        </header>

        <main role="main" id="app-main">
            <router-view></router-view>
        </main>

        <footer class="footer">
            <!-- Current time display -->
            <div class="div-footer">
                <Button outline small @click="toggleUtcTime"
                    ><i class="fa fa-clock" />{{ timeView }}</Button
                >
            </div>

            <!-- Campaign -->
            <div class="div-footer">
                <Button @click="showCampaignSelection = true" outline small>{{
                    campaignLabel
                }}</Button>
            </div>
        </footer>

        <!-- Campaign Selection Modal -->
        <Modal
            v-if="showCampaignSelection"
            noFooter
            scrollBody
            @pageSaveComplete="handlePageSaveComplete"
        >
            <template #header>
                <h3>{{ $t('chooseCampaign') }}</h3>
            </template>
            <template #body>
                <div class="campaign-list">
                    <div
                        class="campaign-slot"
                        v-for="campaign in campaigns"
                        :key="campaign.id"
                        @click="acceptSelectedCampaign(campaign)"
                    >
                        <div class="data-block">
                            <div class="campaign-name">{{ campaign.name }}</div>
                            <div class="campaign-id" v-if="campaign.id">
                                id: {{ campaign.id }}
                            </div>
                        </div>
                        <Label
                            outline
                            transparent
                            :color="campaign.enabled ? 'green' : 'red'"
                            v-if="campaign.id !== null"
                        >
                            {{
                                campaign.enabled
                                    ? $t('enabled')
                                    : $t('disabled')
                            }}
                        </Label>
                    </div>
                </div>
            </template>
        </Modal>

        <Modal
            v-if="unsavedNavRoute"
            @ok="doRouteChange"
            @cancel="unsavedNavRoute = ''"
        >
            <template #header>
                <h3>{{ $t('areYouSure') }}</h3>
            </template>
            <template #body>
                <div>
                    <div class="modal-label">
                        {{ $t('unsavedChangesWarning') }}
                    </div>
                    <div
                        class="modal-save-block"
                        :class="{ saving: modalSaving }"
                    >
                        <div class="spinner-container">
                            <div class="blocks">
                                <div class="block one"></div>
                                <div class="block two"></div>
                                <div class="block three"></div>
                            </div>
                        </div>
                        <div class="button-block">
                            <Button @click="saveCurrentPage">{{
                                $t('save')
                            }}</Button>
                        </div>
                    </div>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import * as auth from '../api/auth';
import { LANGUAGES } from '../constants';

export default {
    data() {
        return {
            currentTime: new Date(),
            displayTimeUTC: false,
            menusOpen: {
                admin: false,
                language: false,
                user: false,
                history: false,
            },
            menusShouldOpen: {
                admin: false,
                language: false,
                user: false,
                history: false,
            },
            navOpen: false,
            navShouldBeOpen: false,
            clickedNavLink: false,
            showCampaignSelection: false,
            timeOptions: [
                {
                    value: 24,
                    label: this.$t('timeOptions.day'),
                },
                {
                    value: 168,
                    label: this.$t('timeOptions.week'),
                },
                {
                    value: 730,
                    label: this.$t('timeOptions.month'),
                },
                {
                    value: -1,
                    label: this.$t('timeOptions.all'),
                },
            ],
            modalSaving: false,
            admin_dsp: 'https://dataserviceplatform.com/PortalV2/Admin/#login',
        };
    },

    watch: {
        $route(to, from) {
            this.navOpen = false;
        },
    },

    computed: {
        ...mapGetters([
            'isUserAdmin',
            'isCampaignViewer',
            'isCampaignManager',
            'isOrganizationAdmin',
        ]),

        ...mapState(['campaignList', 'unitData']),

        appVersion() {
            return TSTAR_CLOUD_VERSION;
        },

        languages() {
            return LANGUAGES;
        },

        campaigns() {
            const allCampaigns = [...this.campaignList];
            const unarchived = allCampaigns
                .sort(this.$store.getters.intlCompareByName)
                .filter((c) => {
                    return !c.archived;
                });
            return [{ id: null, name: 'None' }, ...unarchived];
        },

        username() {
            if (this.$store.state.currentUser) {
                return this.$store.state.currentUser.name;
            } else {
                return '';
            }
        },

        timeView() {
            return this.$store.getters.timeFormatter.format(
                this.$data.currentTime,
            );
        },

        campaignLabel() {
            if (this.$store.state.campaignData) {
                return (
                    this.$t('campaign') +
                    ': ' +
                    this.$store.state.campaignData.name
                );
            } else {
                return this.$t('selectCampaign');
            }
        },

        unsavedNavRoute: {
            get() {
                return this.$store.state.unsavedNavRoute;
            },

            set(value) {
                this.$store.commit('setUnsavedNavRoute', value);
            },
        },
    },

    methods: {
        // When attempting to change routes without saving changes, the user is presented with a modal
        //  and the route they are attempting to go to is stored in Vuex.  Grab that route, tell Vuex
        //  that the user wants to ignore the changes, and navigate to it
        doRouteChange() {
            this.$store.commit('setEditsOnPage', false);
            this.$router.push(this.unsavedNavRoute);
        },

        logout() {
            auth.logout();
        },

        toggleUtcTime() {
            this.$store.commit('toggleTimeFormatUtc');
        },

        acceptSelectedCampaign(selectedCampaign) {
            this.showCampaignSelection = false;

            const campaignId = selectedCampaign.id;
            const campaignName = selectedCampaign.name;

            if (this.$store.state.campaignId !== campaignId) {
                this.$store.commit('setCampaignId', {
                    campaignId,
                    campaignName,
                });
            }
        },

        toggleMenu(menu, event) {
            // If it's already open, it shouldn't reopen
            if (!this.menusOpen[menu]) {
                this.menusShouldOpen[menu] = true;
            }
        },

        closeMenus() {
            Object.keys(this.menusOpen).forEach((key) => {
                if (this.menusShouldOpen[key]) {
                    this.menusOpen[key] = true;
                    this.menusShouldOpen[key] = false;
                } else {
                    this.menusOpen[key] = false;
                }
            });

            this.navOpen = this.navShouldBeOpen;
            this.navShouldBeOpen = false;
        },

        // If the header is clicked on but the hamburger is not, the menu should remain open in mobile
        navClick() {
            if (this.navOpen) {
                this.navShouldBeOpen = true;
            }
        },

        saveCurrentPage() {
            this.modalSaving = true;
            // The following even will be caught by any save widget on the current page which will emit
            //  its own save event.  That event will be grabbed and processed by the data management
            //  component on that page.  When finished, we will know that we can proceed with routing.
            this.$root.$emit('routerModalSave');
        },
    },

    created: function () {
        this.timeUpdate = setInterval(() => {
            this.$data.currentTime = new Date();
        }, 1000);

        document.addEventListener('click', this.closeMenus);
    },

    mounted() {
        if (!this.$store.state.campaignId) {
            if (this.$store.state.campaignList) {
                this.showCampaignSelection = true;
            } else {
                console.warn('no campaigns to prompt user with');
            }
        }
    },

    completePageSave() {
        this.$emit('pageSaveComplete');
    },

    handlePageSaveComplete() {
        if (this.modalSaving) {
            this.modalSaving = false;
            if (!this.$store.state.editsOnPage) {
                this.doRouteChange();
            }
        }
    },

    beforeDestroy: function () {
        clearInterval(this.timeUpdate);

        document.removeEventListener('click', this.closeMenus);
    },
};
</script>
